import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/cursor_left_bottom.png'
import _imports_1 from '@/assets/images/cursor_right_bottom.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1b5d3ffc")

_pushScopeId("data-v-1b5d3ffc")
const _hoisted_1 = { class: "mypagemonthlyfoodsranking-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "mypagemonthlyfoodsranking-page-topspace" }, null, -1)
const _hoisted_3 = { class: "mypagemonthlyfoodsranking-page-top" }
const _hoisted_4 = { class: "mypagemonthlyfoodsranking-page-top-oppanel" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "mypagemonthlyfoodsranking-page-top-oppanel-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "mypagemonthlyfoodsranking-page-top-oppanel-button"
}
const _hoisted_7 = { class: "mypagemonthlyfoodsranking-page-top-oppanel-month" }
const _hoisted_8 = { class: "mypagemonthlyfoodsranking-page-top-oppanel-month-text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "mypagemonthlyfoodsranking-page-top-oppanel-button-image",
  src: _imports_1
}, null, -1)
const _hoisted_10 = {
  key: 3,
  class: "mypagemonthlyfoodsranking-page-top-oppanel-button"
}
const _hoisted_11 = { class: "mypagemonthlyfoodsranking-page-top-updatedate" }
const _hoisted_12 = { class: "mypagemonthlyfoodsranking-page-top-updatedate-text" }
const _hoisted_13 = {
  class: "mypagemonthlyfoodsranking-page-contents-contents",
  id: "mypage-item-parent-id",
  ref: "itemParent"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MypageFoodsRankingContent = _resolveComponent("MypageFoodsRankingContent")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")
  const _component_MypageMonthlyFoodsRankingQuestionDialog = _resolveComponent("MypageMonthlyFoodsRankingQuestionDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_ctx.isValidLeftButton)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "mypagemonthlyfoodsranking-page-top-oppanel-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickLeft(...args)))
            }, [
              _hoisted_5
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_6)),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.currentMonth), 1)
        ]),
        (_ctx.isValidRightButton)
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              class: "mypagemonthlyfoodsranking-page-top-oppanel-button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickRight(...args)))
            }, [
              _hoisted_9
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_10))
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("span", _hoisted_12, _toDisplayString(_ctx.updateDateText), 1)
      ])
    ]),
    _createVNode("div", {
      class: "mypagemonthlyfoodsranking-page-contents",
      id: "mypagemonthlyfoodsranking-page-horizontal-scroll",
      ref: "scroll",
      onScroll: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onScroll($event)))
    }, [
      _createVNode("div", _hoisted_13, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.monthItemList, (monthItem) => {
          return (_openBlock(), _createBlock(_component_MypageFoodsRankingContent, {
            class: "mypagemonthlyfoodsranking-page-contents-contents-item",
            key: monthItem.month,
            userRanking: monthItem.userRanking,
            personalUsedFoodsRanking: monthItem.personalUsedFoodsRanking,
            personalDisposedFoodsRanking: monthItem.personalDisposedFoodsRanking,
            nationwideUsedFoodsRanking: monthItem.nationwideUsedFoodsRanking,
            nationwideDisposedFoodsRanking: monthItem.nationwideDisposedFoodsRanking,
            onClickQuetion: _ctx.clickQuestion,
            onClickUsed: _ctx.clickUsedFoods,
            onClickDisposed: _ctx.clickDisposedFoods
          }, null, 8, ["userRanking", "personalUsedFoodsRanking", "personalDisposedFoodsRanking", "nationwideUsedFoodsRanking", "nationwideDisposedFoodsRanking", "onClickQuetion", "onClickUsed", "onClickDisposed"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512)
    ], 544),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"]),
    _createVNode(_component_MypageMonthlyFoodsRankingQuestionDialog, {
      isShowDialog: _ctx.isShowHelpDialog,
      onClickClose: _ctx.closeHelpDialog
    }, null, 8, ["isShowDialog", "onClickClose"])
  ]))
})